import { styled as o, css as i } from "styled-components";
import { StepProgressBar as s } from "../StepProgressBar/index.js";
import { Theme as t } from "../../styles/themes/index.js";
import { MediaQuery as r } from "../../styles/variables.js";
import { Icon as n } from "../Icon/index.js";
const x = o.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 16px;
  width: 100%;
  border: 0;
  position: relative;

  @media ${r.SCREEN_LG_UP} {
    padding: 26px 78px 38px;
    border-radius: 16px;
    border: 1px solid rgb(${t.colors.Golf});
  }
`, c = o.div`
  max-width: 188px;
  max-height: 200px;
  overflow: hidden;

  @media ${r.SCREEN_LG_UP} {
    max-width: 355px;
    max-height: 240px;
  }
`, h = o.div`
  white-space: nowrap;
  transition: transform 0.3s;
  :nth-child(n) {
    display: inline-flex;
  }
`, b = o(n)`
  font-size: 24px;
  color: rgb(${t.colors.Alpha});
`, e = i`
  display: none;
  @media ${r.SCREEN_LG_UP} {
    display: flex;
    position: absolute;
    z-index: 2;
    background: transparent;

    &[aria-hidden='true'] {
      display: none;
    }
  }
`, f = o.button`
  ${e}
  left: 8px;
`, g = o.button`
  ${e}

  right: 8px;
`, u = o(s)`
  position: absolute;
  bottom: 0;

  span {
    &[aria-pressed='true'] {
      background-color: rgb(${t.colors.Alpha});
    }
  }

  @media ${r.SCREEN_LG_UP} {
    bottom: 16px;
  }
`;
export {
  b as ArrowIcon,
  g as ArrowNext,
  f as ArrowPrev,
  c as Carousel,
  x as Container,
  h as ListImages,
  u as ProgressBar
};
